import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPostmatesComponent } from './simple-icons-postmates.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPostmatesComponent ],
    exports:      [ SimpleIconsPostmatesComponent ],
    bootstrap:    []
})
export class SimpleIconsPostmatesModule {}
